import { c as _c } from "react/compiler-runtime";
import { useFormState } from "react-hook-form";
export const useIsFormSubmitDisabled = control => {
  const $ = _c(6);
  let t0;
  if ($[0] !== control) {
    t0 = {
      control
    };
    $[0] = control;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    isValid,
    errors,
    isSubmitting
  } = useFormState(t0);
  let t1;
  if ($[2] !== errors || $[3] !== isSubmitting || $[4] !== isValid) {
    t1 = Object.keys(errors).length > 0 || !isValid || isSubmitting;
    $[2] = errors;
    $[3] = isSubmitting;
    $[4] = isValid;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};